import { CommonResponse, DataLineChart, ParamsChart } from '@/types/common';
import axiosInstance from "./axiosInstance";
import { AxiosResponse } from 'axios';
import { Allocation, ExchangeOverview, ExchangeHistory } from "@/types/exchange";
import { TransactionFilterParams } from '@/types/filters';
import { cleanFilterParams } from '@/core/utils/filters';

export class ExchangeService {
  private static readonly GET_EXCHANGE_OVERVIEW_ENDPOINT = 'app/exchange/overview';
  private static readonly GET_EXCHANGE_REPORT_ENDPOINT = 'app/exchange/report';
  private static readonly GET_EXCHANGE_HISTORIES_ENDPOINT = 'app/exchange/histories';
  private static readonly GET_EXCHANGE_ALLOCATIONS_ENDPOINT = 'app/exchange/holdings';
  private static readonly GET_EXCHANGE_ORDERS_ENDPOINT = 'app/exchange/orders';

  public static async getExchangeOverview(): Promise<ExchangeOverview> {
    const res: AxiosResponse<ExchangeOverview> = await axiosInstance.get(ExchangeService.GET_EXCHANGE_OVERVIEW_ENDPOINT);
    return res.data;
  }

  public static async getExchangeReport(params: ParamsChart): Promise<DataLineChart> {
    const res: AxiosResponse<DataLineChart> = await axiosInstance.get(ExchangeService.GET_EXCHANGE_REPORT_ENDPOINT, { params });
    return res.data;
  }

  public static async getExchangeHistory(params: { limit?: number, offset: number, isOpen: boolean, filters?: TransactionFilterParams }): Promise<ExchangeHistory> {
    const { limit = 10, offset = 0, isOpen = false, filters } = params;
    const res: AxiosResponse<ExchangeHistory> = await axiosInstance.get(ExchangeService.GET_EXCHANGE_HISTORIES_ENDPOINT, {
      params: {
        limit,
        offset,
        isOpen,
        ...cleanFilterParams(filters),
      }
    });
    return res.data;
  }

  public static async getExchangeAllocations(): Promise<Allocation[]> {
    const res: AxiosResponse<Allocation[]> = await axiosInstance.get(ExchangeService.GET_EXCHANGE_ALLOCATIONS_ENDPOINT);
    return res.data;
  }

  public static async exchangeOrders(payload: any): Promise<any> {
    const res: AxiosResponse<any> = await axiosInstance.post(ExchangeService.GET_EXCHANGE_ORDERS_ENDPOINT, payload);
    return res.data;
  }

  public static async closeOrder(userId: string, orderId: string): Promise<number> {
    const url = ExchangeService.GET_EXCHANGE_ORDERS_ENDPOINT + '/' + userId + '?orderId=' + orderId;
    const res: AxiosResponse<CommonResponse> = await axiosInstance.delete(url);
    return res.status;
  }
}
